export const serviceTheme = {
        token: {
          colorPrimary: "#1677ff",
          colorInfo: "#1677ff",
          colorSuccess: "#52c41a",
          colorWarning: "#faad14",
          colorError: "#ff4d4f",
          colorBgLayout: "#f5f5f5",
          colorBgContainer: "#ffffff",
          colorText: "rgba(0, 0, 0, 0.88)",
          colorTextSecondary: "rgba(0, 0, 0, 0.45)",
          colorBorder: "#d9d9d9",
          colorBorderSecondary: "#f0f0f0",
          fontFamily: '"Segoe UI", "Apple SD Gothic Neo", "Noto Sans KR", Arial, sans-serif',
          fontSize: 13,
          controlHeight: 32,
          controlHeightSM: 24,
          controlHeightLG: 40,
          borderRadius: 6,
          borderRadiusSM: 4,
          borderRadiusLG: 8,
          boxShadowSecondary: "0 6px 16px rgba(0, 0, 0, 0.08)"
        },
        components: {
          Button: {
            fontWeight: 500,
            primaryShadow: "0 2px 0 rgba(5, 145, 255, 0.1)"
          },
          Card: {
            headerHeight: 44,
            headerFontSize: 15,
            paddingLG: 16
          },
          Table: {
            fontSize: 12,
            fontSizeSM: 12,
            headerBg: "#fafafa",
            headerColor: "rgba(0, 0, 0, 0.65)",
            cellPaddingBlock: 9,
            cellPaddingInline: 12
          },
          Modal: {
            titleFontSize: 16
          },
          Tabs: {
            itemSelectedColor: "#1677ff",
            itemHoverColor: "#4096ff"
          }
        }
};
